import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'

import { Button, useTheme } from "@mui/material";
import { tokens } from "../../theme";

import { formatDateCreatedAt } from "../../utils/formats";
const ExportToExcelShowTable = ({ data, kit_number,sellersData }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const preprocessData = (data) => {
        return data.map((item) => ({
            ...item,
            created_at: formatDateCreatedAt(item.created_at), // Format the created_at field
            status: !item?.devolvido ? 'Vendido' : 'Devolvido',
            product_id: item.product_id,
            created_at_hour: formatDateCreatedAt(item.created_at).split('-')[0],
            created_at_time: formatDateCreatedAt(item.created_at).split('-')[1],
            sell_price: parseFloat(item.sell_price)

        }));
    };

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Kit - ' + kit_number, {
            views: [{ showGridLines: false }], // Disable gridlines
        });


        // Add header row
        worksheet.columns = [
            { header: "Produto", key: "product_id", width: 15 },
            { header: "Preço", key: "sell_price", width: 10 },
            { header: "Tipo", key: "content_type", width: 15 },
            { header: "Tamanho", key: "tamanho", width: 10 },
            { header: "Data - Inserido", key: "created_at_hour", width: 15 },
            { header: "Horário - Inserido", key: "created_at_time", width: 15 },
            { header: "Status", key: "status", width: 10 },


            // { header: "PK Kit Product", key: "pk_kit_product", width: 15 },
            // { header: "Color", key: "color", width: 15 },
            // { header: "Quantity", key: "quantity", width: 10 },
            // { header: "Quantity Returned", key: "quantity_returned", width: 15 },
            // { header: "Sold Out", key: "sold_out", width: 10 },
            // { header: "Quantity Sold", key: "quantity_sold", width: 15 },
            // { header: "Returned", key: "devolvido", width: 10 },
        ];

        // Preprocess data
        const processedData = preprocessData(data);

        // Add data rows
        processedData.forEach((item) => {
            const row = worksheet.addRow(item);
            // Set specific cell types
            row.getCell("product_id").numFmt = "0"; // Ensure product_id is treated as a number
            row.getCell("sell_price").numFmt = "#,##0.00"; // Format sell_price as '135,00'

            // Set alignment for the current row
            row.alignment = { vertical: "middle", horizontal: "center" };

            row.eachCell({includeEmpty: true},(cell) => {
                cell.border = {
                    top: { style: "dotted" },
                    left: { style: "dotted" },
                    bottom: { style: "dotted" },
                    right: { style: "dotted" },
                };
            })

        });

        // Style the header row
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true };
        headerRow.alignment = { vertical: "middle", horizontal: "center" };

        // Apply dotted border to the header row
        headerRow.eachCell((cell) => {
            cell.border = {
                // top: { style: "dotted" },
                // left: { style: "dotted" },
                bottom: { style: "double" },
                // right: { style: "dotted" },
            };
        });

        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });

        // Save file
        saveAs(blob, `${sellersData?.user?.slug}_kit_${kit_number}.xlsx`);
    };

    return (
        <Button onClick={exportToExcel}
            sx={{ paddingLeft: '40px' }}
        >
            <FontAwesomeIcon
                size="2xl"
                icon={faFileExcel}
                color={colors.greenAccent[600]}
            />
        </Button>
    );
};

// const styles = {
//     button: {
//         padding: "10px 20px",
//         backgroundColor: "#4CAF50",
//         color: "white",
//         border: "none",
//         borderRadius: "5px",
//         cursor: "pointer",
//         fontSize: "16px",
//     },
// };

export default ExportToExcelShowTable;